<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<p class="FMEP"><span epub:type="pagebreak" id="pg_ix" title="ix">“The story reveals the meaning of what would remain an unbearable sequence of sheer happenings.”</span></p>
<p class="FMEPC1">—H<span class="ePub-SC">ANNAH</span> A<span class="ePub-SC">RENDT</span></p>
<p class="FMEP">“Shit happens.”</p>
<p class="FMEPC">—<span class="ePub-SC">ANONYMOUS</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?042b85fb